import Config from './config'; // Assicurati che il percorso sia corretto
import $ from "utils/net";   // Assicurati che il percorso sia corretto

// --- Interfacce per le risposte API e i payload delle richieste ---

/**
 * Risposta dall'endpoint /poker/accedi
 */
export interface PokerAccediResponse {
    wstoken: string;
    wsbalancecurrency: number;
    // Aggiungi altri campi se l'API li restituisce e sono necessari
}

/**
 * Payload per la richiesta a /poker/balanceTransfer
 */
export interface PokerBalanceTransferRequestPayload {
    amount: number; // Positivo per deposito, negativo per prelievo
}

/**
 * Risposta dall'endpoint /poker/balanceTransfer
 */
export interface PokerBalanceTransferResponse {
    balance?: number; // se status == 'failed' questo è assente
    code: string;
    status: 'done' | 'failed';
    // Aggiungi altri campi se l'API li restituisce, ad esempio uno status
    // status?: 'success' | 'error';
    // message?: string;
}

export class PokerService {
    /**
     * @returns {Promise<PokerAccediResponse>} Una Promise che risolve con i dati utente sulla piattaforma.
     */
    static async getSessionInfo(): Promise<PokerAccediResponse> {
        const url = `${Config.softionAPI}/poker/accedi?json`;
        try {
            const response = await $.promiseGetJSON(url);
            return response as PokerAccediResponse;
        } catch (error) {
            console.error("Errore durante la chiamata a /poker/accedi:", error);
            throw error; // Rilancia l'errore per essere gestito dal chiamante
        }
    }

    /**
     * Trasferisce fondi da o verso il portafoglio poker.
     * @param {number} amount L'importo da trasferire.
     *                        Positivo per depositare nel portafoglio poker.
     *                        Negativo per prelevare dal portafoglio poker.
     * @returns {Promise<PokerBalanceTransferResponse>} Una Promise che risolve con il nuovo saldo.
     */
    static async balanceTransfer(amount: number): Promise<PokerBalanceTransferResponse> {
        const url = `${Config.softionAPI}/poker/balanceTransfer?json`;
        const payload: PokerBalanceTransferRequestPayload = { amount };

        try {
            const response = await $.promisePostJSON(url, {body: payload});
            return response as PokerBalanceTransferResponse;
        } catch (error) {
            console.error("Errore durante la chiamata a /poker/balanceTransfer:", error);
            throw error; // Rilancia l'errore
        }
    }
}
